/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty-pattern */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AppCSS } from "../../../components";
import { Lbl } from "../../../components/labels";
import { ColDiv, RowDiv } from "../../../components/misc/misc.styled";
import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { FileType } from "../../../redux/types";
import {
  setCustomerDetails,
  setCustomerProjectDetails,
  setEstimate,
} from "../../../redux/reducers";

import { CertificateOfCompletion } from "./CertificateOfCompletion";
import { CertificateGenerator } from "./CertificateOfCompletion/CertificateGenerator";
// import { ProgressSlider } from "./ProgressSlider";
import { CustomerDetails } from "./CustomerDetails";
import { InsuranceDetails } from "./InsuranceDetails";
import { MaterialDetails } from "./MaterialDetails";
import { RoofDetails } from "./RoofDetails";
import { InstallationDetails } from "./InstallationDetails";
import { PaymentDetails } from "./PaymentDetails";
import { DocumentDetails } from "./Documents";
import { EstimateDetails } from "./Estimate";
import { GetEstimate, GetEstimateAddOns } from "../../../redux/api/estimate";
import { Estimate, EstimateAddOns } from "../../../redux/types/Estimate";
import { DeleteProject } from "./Delete Project";
import { Tab, Tabs, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { ProjectIcon, TabsBox } from "./projectsDetails.styled";
import LeftArrowIcon from "../../../images/leftArrowIcon.png";
import AppLoader from "../../../components/loader/index";
import {
  INSURANCE_SCOPE_DETAILS,
  TABLABELS,
} from "../../../contants/projectDetails";
import {
  useCustomerById,
  useFetchProjectDetails,
  useProjectById,
} from "../../../apolloClient/hooks/general/fetchHook";
import { getFilesByType } from "../../../utils/project";
import { CustomerProjectDetails } from "../../../redux/types/projectDetails";
import InsuranceScopeTap from "./InsuranceDetails/InsuranceScopeTab";
import { ContractorDetails } from "./ContractorDetails";
import { Invoice } from "./Invoice";
import { Affidavit } from "./Affidavit";
import { Settings } from "./Settings";
import { useAccess } from "../../../hooks/useAccess";
import { Notes } from "./Notes";
import { ProjectModeToggle } from "../../../components/ui/ProjectModeToggle";
import { getProjectModeAccess } from "../../../utils/projectPermissions";
import { ProjectPhaseStepper } from "../../../components/ui/ProjectPhaseStepper";
import {
  PROJECT_PHASES,
  getActivePhaseIndex,
  getProjectStatus,
  getStageNameForTab,
  SETTINGS_TAB,
  AUTOMATED_STAGES,
} from "../../../utils/projectPhases";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";
import { useFetchProjectStages } from "../../../apolloClient/hooks/general/fetchHook";
import { useUpdateStageStatus } from "../../../apolloClient/hooks/general/createHook";
import { useMutation } from "@apollo/client";
import { UPDATE_PROGRESS } from "../../../apolloClient/operation/mutations";

interface DashboardProps {}

export const ProjectDescription: React.FC<DashboardProps> = ({}) => {
  let { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { customerProjectDetails, projectDetails, estimate, estimateAddOns } =
    useAppSelector((state) => state.userReducer);

  const { project, progress, docs, projectMaterials } = projectDetails;
  const [value, setValue] = useState(0);
  const [userFullName, setUsersFullName] = useState<string>("");
  const [projectId, setProjectId] = useState<string>(id);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSkip, setIsSkip] = useState<boolean>(true);
  const [stageConfirmOpen, setStageConfirmOpen] = useState(false);
  const [pendingStageChange, setPendingStageChange] = useState<{ stageName: string; label: string; newValue: boolean } | null>(null);
  const [insuranceFileUrl, setInsuranceFileUrl] = useState<string>("");
  const [userProjectDetails, setuserProjectDetails] =
    useState<CustomerProjectDetails>(null);

  const {
    projectDetails: projectDetailsData,
    loading: projectDetailsLoading,
    error: projectDetailsError,
    refetch,
  } = useFetchProjectDetails({
    projectId: Number(id),
  });

  // Fetch permissions from Redux using useAppSelector
  const permissions = useAppSelector((state) => state.userReducer.permissions);

  // Check if the user has write access for the "PROJECTS" section
  const hasWriteAccess = permissions.some(
    (permission) => permission.name === "PROJECTS" && permission.permission.includes("WRITE")
  );

  // Get project mode access for toggle functionality
  const projectModeAccess = getProjectModeAccess(permissions);

  // Fetch project stages from API
  const { stages, refetch: refetchStages } = useFetchProjectStages({ projectId: Number(id) });
  const { updateStageStatus } = useUpdateStageStatus();
  const [updateProgressMutation] = useMutation(UPDATE_PROGRESS);

  // Flatten nested stages into { STAGE_NAME: completed }
  const stageCompletionMap = useMemo(() => {
    const map: Record<string, boolean> = {};
    stages?.forEach((phase) => {
      map[phase.name] = phase.completed;
      phase.subSections?.forEach((sub) => {
        map[sub.name] = sub.completed;
        sub.subSections?.forEach((nested) => {
          map[nested.name] = nested.completed;
        });
      });
    });
    return map;
  }, [stages]);

  // Handle mode toggle
  const handleModeToggle = (mode: 'operation' | 'manage') => {
    if (mode === 'manage') {
      // Navigate to ProjectWorkflow (manage-project route)
      navigate(`/manage-project/${id}`);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleStageConfirm = async () => {
    if (pendingStageChange) {
      await updateStageStatus(Number(id), pendingStageChange.stageName, pendingStageChange.newValue);
      refetchStages();
    }
    setStageConfirmOpen(false);
    setPendingStageChange(null);
  };

  const handleStageCancel = () => {
    setStageConfirmOpen(false);
    setPendingStageChange(null);
  };

  const handleRefetchProjectDetails = useCallback(() => {
    refetch();
  }, [refetch]);

  // Use the global hook for access permissions
  const { loading: accessLoading } = useAccess();

  useEffect(() => {
    onFetchProjectDetails();
  }, [
    projectDetailsLoading,
    projectDetailsError,
    projectDetailsData,
    dispatch,
    handleRefetchProjectDetails,
  ]);

  useEffect(() => {
    if (!projectDetailsLoading && !projectDetailsError && projectDetailsData) {
      setIsLoading(false);
    }
  }, [
    projectDetailsLoading,
    projectDetailsError,
    projectDetailsData,
    dispatch,
  ]);

  const onFetchProjectDetails = () => {
    if (!projectDetailsLoading && !projectDetailsError && projectDetailsData) {
      dispatch(setCustomerProjectDetails(projectDetailsData));
      const userInsurancescope = getFilesByType(
        projectDetailsData.documents,
        FileType.INSURANCE
      );
      setInsuranceFileUrl(userInsurancescope[0]?.url);
      const userFullName = `${projectDetailsData.customerDetails.firstName} ${projectDetailsData.customerDetails.lastName}`;
      setUsersFullName(userFullName);
    } else if (projectDetailsError) {
      console.error("Error fetching projects:", projectDetailsError);
      setIsLoading(false);
    }
  };

  const onFetchEstimate = async () => {
    try {
      const data = await GetEstimate(Number(id));
      const response = data.data as Estimate;
      if (response) {
        dispatch(setEstimate(response));
      }
    } catch (error) {
      console.log(error);
    }
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const renderTabPanel = (index: number) => {
    const subSectionNames = [
      "CUSTOMER_DETAILS",
      "PROJECT_MEASUREMENTS",
      "MATERIALS",
      "CONTRACTORS",
      "NOTES",
      "ESTIMATE",
      "INSTALLATION_DETAILS",
      "PAYMENT_DETAILS",
      "DOCUMENTS",
      "INVOICE",
      "AFFIDAVIT",
      "COC",
      "SETTINGS",
    ];

    const subSection = permissions
      ?.find((permission) => permission.name === "PROJECTS")
      ?.subSections?.find((sub) => sub.name === subSectionNames[index]);

    const hasWriteAccess = subSection?.permission.includes("WRITE");

    switch (index) {
      case 0:
        return (
          <CustomerDetails
            onFetchProgress={() => {}}
            project={project}
            progress={progress}
            customerDetails={customerProjectDetails.customerDetails}
            refetchCustomerData={refetch}
            rolesData={projectDetailsData?.ProjectRoles}
          />
        );
      case 1:
        return (
          <InsuranceDetails
            project={project}
            estimateAddOns={estimateAddOns}
            insuranceScopeUrl={insuranceFileUrl}
            insuranceScopeDetails={projectDetailsData.insuranceScope}
            customerProjectDetails={projectDetailsData}
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            permissions={hasWriteAccess}
          />
        );
      case 2:
        return <MaterialDetails materials={customerProjectDetails.materials} />;
      case 3:
        return <ContractorDetails materials={customerProjectDetails.materials} />;
      case 4:
        return (
          <Notes
            permissions={hasWriteAccess}
          />
        );
      case 5:
        return (
          <EstimateDetails
            onFetchProject={onFetchEstimate}
            projectId={+id}
            estimate={estimate}
            docs={projectDetailsData?.documents}
          />
        );
      case 6:
        return <InstallationDetails project={customerProjectDetails} />;
      case 7:
        return (
          <PaymentDetails
            paymentDetails={projectDetailsData.paymentDetails}
            project={projectDetailsData}
            onFetchProject={handleRefetchProjectDetails}
            permissions={hasWriteAccess}
          />
        );
      case 8:
        return (
          <DocumentDetails
            onFetchProject={handleRefetchProjectDetails}
            project={projectDetailsData}
            docs={projectDetailsData?.documents}
            permissions={hasWriteAccess}
          />
        );
      // case 8:
      //   return (
      //     <CertificateOfCompletion
      //       project={project}
      //       docs={docs}
      //       estimateAddOns={estimateAddOns}
      //       onFetchProject={() => {}}
      //     />
      //   );
      case 9:
        return (
          <Invoice
            project={projectDetailsData}
            onFetchProject={handleRefetchProjectDetails}
            permissions={hasWriteAccess}
          />
        );
      case 10:
        return (
          <Affidavit
            project={projectDetailsData}
            onFetchProject={handleRefetchProjectDetails}
            permissions={hasWriteAccess}
          />
        );
      case 11:
        return (
          <CertificateGenerator
            permissions={hasWriteAccess}
          />
        );
      case 12:
        return (
          <Settings
            project={customerProjectDetails}
            docs={docs}
            onDelete={() => navigate(-1)}
            permissions={hasWriteAccess}
          />
        );
      default:
        return null;
    }
  };

  // Filter tabs based on permissions, but always include CUSTOMER_DETAILS
  // Also create a mapping of visual index to original index
  const tabIndexMapping: number[] = [];
  const filteredTabLabels = TABLABELS.filter((label, index) => {
    const subSectionNames = [
      "CUSTOMER_DETAILS",
      "PROJECT_MEASUREMENTS",
      "MATERIALS",
      "CONTRACTORS",
      "NOTES",
      "ESTIMATE",
      "INSTALLATION_DETAILS",
      "PAYMENT_DETAILS",
      "DOCUMENTS",
      "INVOICE",
      "AFFIDAVIT",
      "COC",
      "SETTINGS",
    ];

    // Always include CUSTOMER_DETAILS (index 0)
    if (index === 0) {
      tabIndexMapping.push(index);
      return true;
    }

    // Hide Affidavit tab for CASH payment projects (index 10)
    if (index === 10 && projectDetailsData?.PaymentType === "CASH") {
      return false;
    }

    const subSection = permissions
      ?.find((permission) => permission.name === "PROJECTS")
      ?.subSections?.find((sub) => sub.name === subSectionNames[index]);

    const hasPermission = subSection?.permission.includes("READ");
    if (hasPermission) {
      tabIndexMapping.push(index);
    }
    return hasPermission;
  });

  // Calculate phase completions from API stages
  const PHASE_STAGE_NAMES = ["PROJECT_PREPARATION", "INSTALLATION", "FINALIZATION"];
  const phaseCompletions = PROJECT_PHASES.map((_, i) => {
    const apiPhase = stages?.find((s) => s.name === PHASE_STAGE_NAMES[i]);
    return apiPhase?.completionPercentage ?? 0;
  });

  // Get active phase based on current tab
  const currentTabLabel = filteredTabLabels[value];
  const activePhaseIndex = getActivePhaseIndex(currentTabLabel);

  // Get project status from API phase completions
  const projectStatus: { label: string; color: string } =
    phaseCompletions[2] === 100
      ? { label: "Completed", color: "#10b981" }
      : phaseCompletions[1] > 0
      ? { label: "In Progress", color: "#f59e0b" }
      : { label: "Active", color: "#3b82f6" };

  // Handle phase click to navigate to first tab of that phase
  const handlePhaseClick = (phaseIndex: number) => {
    const phase = PROJECT_PHASES[phaseIndex];
    const firstTabOfPhase = phase.tabs.find((tab) =>
      filteredTabLabels.includes(tab)
    );
    if (firstTabOfPhase) {
      const tabIndex = filteredTabLabels.indexOf(firstTabOfPhase);
      setValue(tabIndex);
    }
  };

  // Mark the 'Completion' progress step (step 5) as complete/incomplete
  const completionProgress = projectDetailsData?.progress?.find((p) => p.step === 5);
  const isCompletionDone = completionProgress?.completed ?? false;

  const handleMarkComplete = async () => {
    if (!completionProgress) {
      toast.info("No completion progress record found.", { position: "top-right", autoClose: 2000 });
      return;
    }
    const newState = !isCompletionDone;
    await updateProgressMutation({
      variables: {
        input: {
          Id: completionProgress.id,
          projectId: Number(id),
          completed: newState,
        },
      },
    });
    refetch();
    toast.success(newState ? "Project marked as complete!" : "Project marked as incomplete.", { position: "top-right", autoClose: 3000 });
  };

  if (isLoading || accessLoading) {
    return <AppLoader isLoading={isLoading || accessLoading} />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        padding: { xs: "16px", md: "24px" },
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            gap: 2,
            marginBottom: 3,
            backgroundColor: "white",
            padding: { xs: "16px", md: "20px" },
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <ProjectIcon
              src={LeftArrowIcon}
              onClick={() => navigate(-1)}
              style={{
                cursor: "pointer",
                width: "24px",
                height: "24px",
              }}
            />
            <Box>
              <Box>
                <Box
                  sx={{
                    fontSize: { xs: "20px", md: "28px" },
                    fontWeight: 600,
                    color: "#1f2937",
                    lineHeight: 1.2,
                  }}
                >
                  {userFullName}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    marginTop: "4px",
                  }}
                >
                  <Box
                    sx={{
                      fontSize: { xs: "12px", md: "14px" },
                      color: "#6b7280",
                    }}
                  >
                    Project ID: {projectId}
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: projectStatus.color,
                      color: "white",
                      padding: "2px 8px",
                      borderRadius: "12px",
                      fontSize: "11px",
                      fontWeight: 600,
                    }}
                  >
                    {projectStatus.label}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: { xs: "100%", md: "auto" } }}>
            {/* Mark as Complete Button */}
            <Box
              onClick={handleMarkComplete}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: { xs: "7px 14px", md: "8px 18px" },
                borderRadius: "10px",
                cursor: "pointer",
                flex: { xs: 1, md: "none" },
                justifyContent: { xs: "center", md: "flex-start" },
                transition: "all 0.2s",
                ...(isCompletionDone
                  ? {
                      background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                      boxShadow: "0 2px 8px rgba(16,185,129,0.35)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                        boxShadow: "0 4px 12px rgba(16,185,129,0.45)",
                        transform: "translateY(-1px)",
                      },
                    }
                  : {
                      background: "transparent",
                      border: "1.5px solid #d1d5db",
                      "&:hover": {
                        borderColor: "#10b981",
                        background: "#f0fdf4",
                        "& .mark-complete-icon": { color: "#10b981" },
                        "& .mark-complete-label": { color: "#10b981" },
                      },
                    }),
              }}
            >
              {isCompletionDone ? (
                <>
                  <Box
                    sx={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(255,255,255,0.25)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      component="svg"
                      viewBox="0 0 10 8"
                      sx={{ width: "10px", height: "8px" }}
                    >
                      <path
                        d="M1 4l3 3 5-6"
                        stroke="white"
                        strokeWidth="1.8"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </Box>
                  </Box>
                  <Box sx={{ fontSize: { xs: "12px", md: "13px" }, fontWeight: 600, color: "white", letterSpacing: "0.2px" }}>
                    Completed
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    className="mark-complete-icon"
                    sx={{
                      width: "16px",
                      height: "16px",
                      borderRadius: "4px",
                      border: "1.5px solid #9ca3af",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      transition: "all 0.2s",
                    }}
                  />
                  <Box
                    className="mark-complete-label"
                    sx={{ fontSize: { xs: "12px", md: "13px" }, fontWeight: 500, color: "#6b7280", transition: "all 0.2s" }}
                  >
                    Mark Complete
                  </Box>
                </>
              )}
            </Box>

            {/* Toggle Button - only show if user has access to both modes */}
            {projectModeAccess.canToggleModes && (
              <ProjectModeToggle
                currentMode="operation"
                onModeChange={handleModeToggle}
              />
            )}
          </Box>
        </Box>

        {/* Phase Stepper - desktop only */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <ProjectPhaseStepper
            activePhaseIndex={activePhaseIndex}
            phaseCompletions={phaseCompletions}
            onPhaseClick={handlePhaseClick}
          />
        </Box>

        {/* Tabs and Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, md: 3 },
          }}
        >
          {/* Sidebar Navigation - Desktop */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              width: "280px",
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                padding: "16px",
                position: "sticky",
                top: "24px",
                maxHeight: "calc(100vh - 48px)",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#d1d5db",
                  borderRadius: "3px",
                  "&:hover": {
                    backgroundColor: "#9ca3af",
                  },
                },
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                {PROJECT_PHASES.map((phase, phaseIdx) => {
                  const phaseTabs = phase.tabs.filter((tab) =>
                    filteredTabLabels.includes(tab)
                  );
                  if (phaseTabs.length === 0) return null;

                  return (
                    <Box
                      key={phase.id}
                      sx={{
                        backgroundColor: `${phase.color}08`,
                        borderRadius: "8px",
                        padding: "8px",
                        marginTop: phaseIdx > 0 ? "12px" : "0",
                      }}
                    >
                      {/* Phase Header with Background Color */}
                      <Box
                        sx={{
                          padding: "10px 12px",
                          marginBottom: "6px",
                          backgroundColor: `${phase.color}15`,
                          borderRadius: "8px",
                          borderLeft: `4px solid ${phase.color}`,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Box sx={{ fontSize: "16px" }}>{phase.icon}</Box>
                          <Box
                            sx={{
                              fontSize: "12px",
                              fontWeight: 700,
                              color: phase.color,
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {phase.title}
                          </Box>
                        </Box>
                      </Box>

                      {/* Phase Tabs */}
                      {phaseTabs.map((tabLabel) => {
                        const tabIndex = filteredTabLabels.indexOf(tabLabel);
                        const isSelected = value === tabIndex;
                        const stageName = getStageNameForTab(tabLabel);
                        const isCompleted = stageCompletionMap[stageName] ?? false;
                        const isAutomated = AUTOMATED_STAGES.has(tabLabel);
                        const isNoCheckbox = tabLabel === "Notes" || tabLabel === "Documents" || tabLabel === "Settings";

                        const handleCheckboxClick = (e: React.MouseEvent) => {
                          e.stopPropagation();
                          if (!stageName) return;
                          setPendingStageChange({ stageName, label: tabLabel, newValue: !isCompleted });
                          setStageConfirmOpen(true);
                        };

                        return (
                          <Box
                            key={tabLabel}
                            onClick={() => setValue(tabIndex)}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              padding: "10px 12px",
                              marginLeft: "20px",
                              marginBottom: "2px",
                              borderRadius: "8px",
                              cursor: "pointer",
                              backgroundColor: isSelected ? phase.color : "transparent",
                              color: isSelected ? "white" : "#4b5563",
                              transition: "all 0.2s",
                              "&:hover": {
                                backgroundColor: isSelected ? phase.color : "#f3f4f6",
                              },
                            }}
                          >
                            {isNoCheckbox ? (
                              /* Notes / Documents — no checkbox */
                              <Box sx={{ fontSize: "14px", width: "16px", textAlign: "center" }}>
                                {tabLabel === "Notes" ? "📝" : "📄"}
                              </Box>
                            ) : isAutomated ? (
                              /* Automated — circle, display only */
                              <Box
                                sx={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  border: `2px solid ${isSelected ? "white" : isCompleted ? phase.color : "#d1d5db"}`,
                                  backgroundColor: isCompleted
                                    ? isSelected ? "white" : phase.color
                                    : "transparent",
                                  flexShrink: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {isCompleted && (
                                  <Box
                                    sx={{
                                      width: "6px",
                                      height: "6px",
                                      borderRadius: "50%",
                                      backgroundColor: isSelected ? phase.color : "white",
                                    }}
                                  />
                                )}
                              </Box>
                            ) : (
                              /* Manual — square checkbox, clickable */
                              <Box
                                onClick={handleCheckboxClick}
                                sx={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "3px",
                                  border: `2px solid ${isSelected ? "white" : isCompleted ? phase.color : "#d1d5db"}`,
                                  backgroundColor: isCompleted
                                    ? isSelected ? "white" : phase.color
                                    : "transparent",
                                  flexShrink: 0,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  "&:hover": {
                                    borderColor: isSelected ? "white" : phase.color,
                                  },
                                }}
                              >
                                {isCompleted && (
                                  <Box
                                    component="svg"
                                    viewBox="0 0 10 8"
                                    sx={{ width: "10px", height: "8px" }}
                                  >
                                    <path
                                      d="M1 4l3 3 5-6"
                                      stroke={isSelected ? phase.color : "white"}
                                      strokeWidth="1.5"
                                      fill="none"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </Box>
                                )}
                              </Box>
                            )}
                            <Box
                              sx={{
                                fontSize: "13px",
                                fontWeight: isSelected ? 600 : 500,
                                flex: 1,
                              }}
                            >
                              {tabLabel}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })}

                {/* Settings - Separate */}
                {filteredTabLabels.includes(SETTINGS_TAB) && (
                  <Box
                    sx={{
                      backgroundColor: "#6b728008",
                      borderRadius: "8px",
                      padding: "8px",
                      marginTop: "12px",
                    }}
                  >
                    {/* Settings Header with Background Color */}
                    <Box
                      sx={{
                        padding: "10px 12px",
                        marginBottom: "6px",
                        backgroundColor: "#6b728015",
                        borderRadius: "8px",
                        borderLeft: "4px solid #6b7280",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Box sx={{ fontSize: "16px" }}>⚙️</Box>
                        <Box
                          sx={{
                            fontSize: "12px",
                            fontWeight: 700,
                            color: "#6b7280",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Settings
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      onClick={() =>
                        setValue(filteredTabLabels.indexOf(SETTINGS_TAB))
                      }
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        padding: "10px 12px",
                        marginLeft: "20px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        backgroundColor:
                          value === filteredTabLabels.indexOf(SETTINGS_TAB)
                            ? "#6b7280"
                            : "transparent",
                        color:
                          value === filteredTabLabels.indexOf(SETTINGS_TAB)
                            ? "white"
                            : "#4b5563",
                        transition: "all 0.2s",
                        "&:hover": {
                          backgroundColor:
                            value === filteredTabLabels.indexOf(SETTINGS_TAB)
                              ? "#6b7280"
                              : "#f3f4f6",
                        },
                      }}
                    >
                      {/* Settings icon instead of checkbox */}
                      <Box sx={{ fontSize: "16px" }}>⚙️</Box>
                      <Box
                        sx={{
                          fontSize: "13px",
                          fontWeight:
                            value === filteredTabLabels.indexOf(SETTINGS_TAB)
                              ? 600
                              : 500,
                          flex: 1,
                        }}
                      >
                        {SETTINGS_TAB}
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          {/* Mobile Tabs - compact 2-row navigator */}
          <Box
            sx={{
              display: { xs: "block", md: "none" },
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: "10px 12px",
            }}
          >
            {/* Row 1: Phase selector pills */}
            <Box sx={{ display: "flex", gap: "6px", marginBottom: "8px", overflowX: "auto", "&::-webkit-scrollbar": { display: "none" } }}>
              {PROJECT_PHASES.map((phase, phaseIdx) => {
                const phaseTabs = phase.tabs.filter((tab) => filteredTabLabels.includes(tab));
                if (phaseTabs.length === 0) return null;
                const isActivePhase = activePhaseIndex === phaseIdx;
                const phaseCompletion = phaseCompletions[phaseIdx] || 0;
                return (
                  <Box
                    key={phase.id}
                    onClick={() => handlePhaseClick(phaseIdx)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      padding: "5px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: isActivePhase ? 700 : 500,
                      color: isActivePhase ? "white" : phase.color,
                      backgroundColor: isActivePhase ? phase.color : `${phase.color}12`,
                      border: `1px solid ${phase.color}40`,
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      cursor: "pointer",
                    }}
                  >
                    {phase.icon} {phase.title}
                    {phaseCompletion > 0 && phaseCompletion < 100 && (
                      <Box sx={{ fontSize: "10px", opacity: 0.8 }}>·{phaseCompletion}%</Box>
                    )}
                    {phaseCompletion === 100 && (
                      <CheckCircleIcon sx={{ fontSize: "11px" }} />
                    )}
                  </Box>
                );
              })}
              {filteredTabLabels.includes(SETTINGS_TAB) && (
                <Box
                  onClick={() => setValue(filteredTabLabels.indexOf(SETTINGS_TAB))}
                  sx={{
                    padding: "5px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: value === filteredTabLabels.indexOf(SETTINGS_TAB) ? 700 : 500,
                    color: value === filteredTabLabels.indexOf(SETTINGS_TAB) ? "white" : "#6b7280",
                    backgroundColor: value === filteredTabLabels.indexOf(SETTINGS_TAB) ? "#6b7280" : "#6b728012",
                    border: "1px solid #6b728040",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    cursor: "pointer",
                  }}
                >
                  ⚙️ Settings
                </Box>
              )}
            </Box>

            {/* Row 2: Only active phase's tabs */}
            <Box sx={{ display: "flex", gap: "6px", overflowX: "auto", "&::-webkit-scrollbar": { display: "none" } }}>
              {(() => {
                const activePhase = PROJECT_PHASES[activePhaseIndex];
                const tabsToShow = activePhase
                  ? activePhase.tabs.filter((tab) => filteredTabLabels.includes(tab))
                  : value === filteredTabLabels.indexOf(SETTINGS_TAB)
                  ? [SETTINGS_TAB]
                  : [];
                const color = activePhase?.color || "#6b7280";
                return tabsToShow.map((label) => {
                  const index = filteredTabLabels.indexOf(label);
                  const isSelected = value === index;
                  const stageName = getStageNameForTab(label);
                  const isCompleted = stageCompletionMap[stageName] ?? false;
                  const isAutomated = AUTOMATED_STAGES.has(label);
                  const isNoCheckbox = label === "Notes" || label === "Documents" || label === "Settings";

                  const handleMobileCheckbox = (e: React.MouseEvent) => {
                    e.stopPropagation();
                    if (!stageName || isAutomated) return;
                    setPendingStageChange({ stageName, label, newValue: !isCompleted });
                    setStageConfirmOpen(true);
                  };

                  return (
                    <Box
                      key={label}
                      onClick={() => setValue(index)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        padding: "6px 10px",
                        fontSize: "13px",
                        fontWeight: isSelected ? 600 : 400,
                        color: isSelected ? "white" : "#4b5563",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        backgroundColor: isSelected ? color : "transparent",
                        border: isSelected ? "none" : "1px solid #e5e7eb",
                        cursor: "pointer",
                        transition: "all 0.15s",
                      }}
                    >
                      {!isNoCheckbox && (
                        <Box
                          onClick={!isAutomated ? handleMobileCheckbox : undefined}
                          sx={{
                            width: "14px",
                            height: "14px",
                            borderRadius: isAutomated ? "50%" : "3px",
                            border: `2px solid ${isSelected ? "white" : isCompleted ? color : "#d1d5db"}`,
                            backgroundColor: isCompleted
                              ? isSelected ? "white" : color
                              : "transparent",
                            flexShrink: 0,
                            cursor: isAutomated ? "default" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {isCompleted && !isAutomated && (
                            <Box component="svg" viewBox="0 0 10 8" sx={{ width: "9px", height: "7px" }}>
                              <path
                                d="M1 4l3 3 5-6"
                                stroke={isSelected ? color : "white"}
                                strokeWidth="1.5"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </Box>
                          )}
                          {isCompleted && isAutomated && (
                            <Box sx={{ width: "5px", height: "5px", borderRadius: "50%", backgroundColor: isSelected ? color : "white" }} />
                          )}
                        </Box>
                      )}
                      {label}
                    </Box>
                  );
                });
              })()}
            </Box>
          </Box>

          {/* Content Area */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: { xs: "16px", md: "24px" },
              minHeight: { xs: "auto", md: "calc(100vh - 200px)" },
              maxHeight: { xs: "none", md: "calc(100vh - 200px)" },
              overflowY: "auto",
            }}
          >
            {renderTabPanel(tabIndexMapping[value] ?? value)}
          </Box>
        </Box>
      </Box>

      <Dialog
        open={stageConfirmOpen}
        onClose={handleStageCancel}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
            maxWidth: "400px",
            width: { xs: "calc(100% - 32px)", sm: "400px" },
            margin: { xs: "16px", sm: "auto" },
            boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
          },
        }}
      >
        <DialogTitle sx={{ pb: 1, pt: 2, px: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "10px",
                backgroundColor: pendingStageChange?.newValue ? "#ecfdf5" : "#fff7ed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                flexShrink: 0,
              }}
            >
              {pendingStageChange?.newValue ? "✓" : "○"}
            </Box>
            <Box sx={{ fontSize: { xs: "15px", sm: "16px" }, fontWeight: 600, color: "#111827" }}>
              Update Stage
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ px: 3, pt: 1, pb: 2 }}>
          <DialogContentText sx={{ fontSize: { xs: "13px", sm: "14px" }, color: "#6b7280", lineHeight: 1.6 }}>
            Mark <Box component="span" sx={{ fontWeight: 600, color: "#111827" }}>{pendingStageChange?.label}</Box> as{" "}
            <Box component="span" sx={{ fontWeight: 600, color: pendingStageChange?.newValue ? "#10b981" : "#f59e0b" }}>
              {pendingStageChange?.newValue ? "completed" : "incomplete"}
            </Box>?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, pt: 0, gap: 1 }}>
          <Button
            onClick={handleStageCancel}
            fullWidth
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "14px",
              color: "#6b7280",
              backgroundColor: "#f3f4f6",
              py: 1.2,
              "&:hover": { backgroundColor: "#e5e7eb" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleStageConfirm}
            fullWidth
            sx={{
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
              color: "white",
              backgroundColor: pendingStageChange?.newValue ? "#10b981" : "#f59e0b",
              py: 1.2,
              "&:hover": {
                backgroundColor: pendingStageChange?.newValue ? "#059669" : "#d97706",
              },
            }}
          >
            {pendingStageChange?.newValue ? "Mark Complete" : "Mark Incomplete"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
